import { HgSupportedLanguage, TargetPlatform } from '@smg-real-estate/hg-search-libs';

import { useGeoStore } from '@/store/modules/geo';

export function urlNameByGeoIdResolver(
  geoStore: ReturnType<typeof useGeoStore>,
  targetPlatform: TargetPlatform,
) {
  return (locationId: string, language: HgSupportedLanguage): string | undefined => {
    const geoLocation = geoStore.getGeoLocationById(locationId);

    return targetPlatform === TargetPlatform.IMMOSCOUT24
      ? geoLocation?.is24UrlNames?.[language]
      : geoLocation?.urlNames[language];
  };
}
